import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { Package, Truck, MapPin, CheckCircle2 } from "lucide-react";
import { logger } from "@/lib/logger";

const ICONS = { label_created: Package, picked_up: Truck, in_transit: Truck, out_for_delivery: MapPin, delivered: CheckCircle2, exception: Package };

export default function TrackShipment() {
  const { tracking_number } = useParams();
  const [rec, setRec] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    let cancelled = false;
    api.get(`/track/${tracking_number}`)
      .then(r => { if (!cancelled) setRec(r.data); })
      .catch(loadErr => { if (!cancelled) { logger.warn("Track load failed:", loadErr); setErr("Tracking number not found"); } });
    return () => { cancelled = true; };
  }, [tracking_number]);

  return (
    <section className="max-w-[820px] mx-auto px-6 py-24">
      <p className="text-xs font-mono tracking-[0.3em] uppercase text-[#C5A059]">Track Shipment</p>
      <h1 className="font-serif text-5xl md:text-6xl mt-3">Where's my order?</h1>
      {err && <p className="mt-8 text-[#9A1F1F]" data-testid="track-error">{err}</p>}
      {rec && (
        <div className="mt-10">
          <div className="border border-[#E5E5E5] p-6 flex flex-wrap justify-between gap-4">
            <div>
              <p className="text-xs font-mono uppercase tracking-widest text-[#888]">Tracking</p>
              <p className="font-mono text-lg" data-testid="track-number">{rec.tracking_number}</p>
              <p className="text-sm text-[#555]">{rec.carrier.toUpperCase()}{rec.service ? ` · ${rec.service}` : ""}</p>
            </div>
            <div className="text-right">
              <p className="text-xs font-mono uppercase tracking-widest text-[#888]">Status</p>
              <p className="font-serif text-2xl text-[#C5A059]" data-testid="track-status">{rec.status.replace(/_/g," ")}</p>
            </div>
          </div>
          <div className="mt-8 border-l-2 border-[#C5A059] pl-8 space-y-6">
            {rec.history.slice().reverse().map((h) => {
              const Icon = ICONS[h.status] || Package;
              return (
                <div key={`${h.at}-${h.status}`} className="relative" data-testid={`track-event-${h.status}`}>
                  <div className="absolute -left-[42px] w-6 h-6 bg-[#0a0a0a] flex items-center justify-center">
                    <Icon size={12} className="text-[#C5A059]" strokeWidth={2} />
                  </div>
                  <p className="font-serif text-xl">{h.status.replace(/_/g," ")}</p>
                  <p className="text-xs font-mono text-[#888] mt-1">{new Date(h.at).toLocaleString()}</p>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </section>
  );
}
